module.exports = __webpack_public_path__ + "img/15.c281b244.png";